import React, { useState, useEffect } from "react";
import './App.css';

const categories = [
    "Shelter", "Sleep System", "Cooking", "Navigation", "First Aid", "Clothing",
    "Tools", "Food", "Miscellaneous", "Water", "Backpack"
];

const PackingList = () => {
    const [items, setItems] = useState([]);
    const [categoryInputs, setCategoryInputs] = useState(
        categories.reduce((acc, category) => {
            acc[category] = { manufacturer: "", name: "", weight: "", volume: "" };
            return acc;
        }, {})
    );

    const [notifications, setNotifications] = useState(
        categories.reduce((acc, category) => {
            acc[category] = null;
            return acc;
        }, {})
    );

    // 🔹 Päivittää iframen korkeuden Shopify-sivulla
    useEffect(() => {
        function sendHeight() {
            const height = document.documentElement.scrollHeight;
            window.parent.postMessage({ type: "SET_IFRAME_HEIGHT", height }, "*");
        }

        sendHeight();
        window.addEventListener("resize", sendHeight);

        return () => {
            window.removeEventListener("resize", sendHeight);
        };
    }, [items]); // 🔹 Korkeus päivittyy myös, kun tuotteita lisätään tai poistetaan

    const addItem = (category) => {
        const newItem = categoryInputs[category];

        if (newItem.manufacturer && newItem.name && newItem.weight && newItem.volume) {
            setItems([...items, { ...newItem, category, id: Date.now() }]);

            setCategoryInputs({
                ...categoryInputs,
                [category]: { manufacturer: "", name: "", weight: "", volume: "" }
            });

            setNotifications({
                ...notifications,
                [category]: "✅ Varuste lisätty! Katso lista alhaalta."
            });

            setTimeout(() => {
                setNotifications({
                    ...notifications,
                    [category]: null
                });
            }, 3000);
        }
    };

    const removeItem = (id) => {
        setItems(items.filter(item => item.id !== id));
    };

    const backpack = items.find(item => item.category === "Backpack");
    const backpackVolume = backpack ? parseFloat(backpack.volume) : 0;
    const totalVolume = items
        .filter(item => item.category !== "Backpack")
        .reduce((sum, item) => sum + parseFloat(item.volume), 0);

    const baseWeightKg = items
        .filter(item => item.category !== "Food")
        .reduce((sum, item) => sum + parseFloat(item.weight) / 1000, 0);

    const totalWeightKg = items.reduce((sum, item) => sum + parseFloat(item.weight) / 1000, 0);

    return (
        <div className="container">
            <div className="logo-container">
                <img src="https://i.ibb.co/JFCb15Dv/northernlite-logo.png" alt="Northern Lite Logo" />
            </div>

            <header className="header">
                <h1>Vaellusvarusteiden painolaskuri</h1>
                <p>Laske ja optimoi varusteidesi paino vaellusseikkailuihin</p>
            </header>

            <div className="info-box">
                <ul>
                    <li>1. Valitse varustekategoria ja täytä kaikki kentät</li>
                    <li>2. Syötä valmistaja, nimi, paino ja tilavuus</li>
                    <ol>VINKKI: kannattaa punnita kaikki varusteet keittiövaalla ja käyttää tilavuuden arvioimiseen mielikuvaa litran vesipullosta.</ol>
                    <li>3. Lisää varuste listaan</li>
                    <li>4. Näe lista, peruspaino (paino ilman ruokia ja vesiä) sekä kokonaispaino automaattisesti sivun lopusta</li>
                    <li>5. Jos lisäät myös repun ja sen tilavuuden, niin arvioimme mahtuvatko kaikki varusteesi annettuun repun pakkaustilavuuteen</li>
                </ul>
            </div>

            <div className="categories-container">
                {categories.map((category) => (
                    <div key={category} className="category-card">
                        <h2>{category}</h2>

                        {notifications[category] && (
                            <p className="category-notification">{notifications[category]}</p>
                        )}

                        <div className="input-container">
                            <label>Valmistaja</label>
                            <input
                                type="text"
                                placeholder="Enter manufacturer"
                                value={categoryInputs[category].manufacturer}
                                onChange={(e) => setCategoryInputs({
                                    ...categoryInputs,
                                    [category]: { ...categoryInputs[category], manufacturer: e.target.value }
                                })}
                            />
                        </div>
                        <div className="input-container">
                            <label>Varusteen nimi</label>
                            <input
                                type="text"
                                placeholder="Enter item name"
                                value={categoryInputs[category].name}
                                onChange={(e) => setCategoryInputs({
                                    ...categoryInputs,
                                    [category]: { ...categoryInputs[category], name: e.target.value }
                                })}
                            />
                        </div>
                        <div className="input-container">
                            <label>Paino (g)</label>
                            <input
                                type="number"
                                placeholder="0"
                                value={categoryInputs[category].weight}
                                onChange={(e) => setCategoryInputs({
                                    ...categoryInputs,
                                    [category]: { ...categoryInputs[category], weight: e.target.value }
                                })}
                            />
                        </div>
                        <div className="input-container">
                            <label>Tilavuus (L)</label>
                            <input
                                type="number"
                                placeholder="0.0"
                                value={categoryInputs[category].volume}
                                onChange={(e) => setCategoryInputs({
                                    ...categoryInputs,
                                    [category]: { ...categoryInputs[category], volume: e.target.value }
                                })}
                            />
                        </div>
                        <button className="add-item-button" onClick={() => addItem(category)}>Lisää varuste</button>
                    </div>
                ))}
            </div>

            <div className="summary-list" id="summary">
                <h2>Lisätyt varusteet</h2>
                {categories.map((category) => {
                    const categoryItems = items.filter(item => item.category === category);
                    if (categoryItems.length === 0) return null;
                    return (
                        <div key={category} className="category-summary">
                            <h3>{category}</h3>
                            <ul>
                                {categoryItems.map((item) => (
                                    <li key={item.id}>
                                        <strong>{item.manufacturer}</strong> - {item.name}
                                        ({item.weight} g, {item.volume} L)
                                        <button className="remove-btn" onClick={() => removeItem(item.id)}>Poista</button>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    );
                })}
            </div>

            <div className="summary">
                <h2>Yhteenveto</h2>
                <p><strong>Peruspaino (pl. ruoka):</strong> {baseWeightKg.toFixed(2)} kg</p>
                <p><strong>Kokonaispaino:</strong> {totalWeightKg.toFixed(2)} kg</p>

                {backpack && (
                    <p>
                        <strong>Repun tilavuus:</strong> {backpackVolume} L <br />
                        {totalVolume > backpackVolume ? "❌ Ei mahdu reppuun! Harkitse karsimista." : "✅ Mahtuu reppuun!"}
                    </p>
                )}
            </div>
        </div>
    );
};

export default PackingList;